import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaHandshake,
  FaArrowRight,
} from "react-icons/fa";

export default function PartnerWithUs({ open, setOpen }) {

  // ✅ Detect Route / Modal
  const isRoute = open === undefined;

  const [form, setForm] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Address: "",
    Country: "",
    State: "",
    City: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ API Base URL from env
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  // ✅ About Us ki tarh top se open
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // ✅ Modal hide
  if (!isRoute && !open) return null;

  // ================= INPUT =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ================= IMAGE =================
  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {

    if (!form.Name || !form.Email || !form.Phone) {
      alert("Please fill required fields");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("Name", form.Name);
      formData.append("Email", form.Email);
      formData.append("Phone", form.Phone);
      formData.append("Address", form.Address);
      formData.append("Country", form.Country);
      formData.append("State", form.State);
      formData.append("City", form.City);

      if (image) {
        formData.append("Image", image);
      }

      // ✅ Using env URL
      const res = await axios.post(
        `${API_BASE_URL}Customer/InsertPartner`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("✅ API SUCCESS:", res.data);

      alert("Partner request submitted successfully");

      // RESET
      setForm({
        Name: "",
        Email: "",
        Phone: "",
        Address: "",
        Country: "",
        State: "",
        City: "",
      });

      setImage(null);

      // CLOSE ONLY MODAL
      if (setOpen) {
        setOpen(false);
      }

    } catch (err) {
      console.log("❌ ERROR:", err.response || err);
      alert("Submission failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={
        isRoute
          ? "w-full min-h-screen bg-gradient-to-br from-gray-50 via-white to-red-50"
          : "fixed inset-0 z-50 flex items-center justify-center"
      }
    >

      {/* MODAL BACKDROP */}
      {!isRoute && (
        <div
          className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          onClick={() => setOpen && setOpen(false)}
        />
      )}

      {/* MAIN CONTAINER */}
      <div
        className={`relative w-full ${
          isRoute
            ? ""
            : "max-w-5xl rounded-3xl overflow-hidden"
        } bg-white shadow-2xl`}
      >

        {/* ================= TOP SECTION ================= */}
        <div className="relative overflow-hidden bg-gradient-to-r from-red-600 via-red-500 to-red-400 text-white">

          {/* BG */}
          <div className="absolute -top-8 -left-8 w-28 h-28 bg-white/10 rounded-full"></div>

          <div className="absolute top-0 right-0 w-44 h-44 bg-white/10 rounded-full"></div>

          {/* CLOSE */}
          {!isRoute && (
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-5 text-xl z-20"
            >
              ✕
            </button>
          )}

          <div className="relative z-10 px-6 md:px-16 py-8 md:py-10 text-center">

            {/* ICON */}
            <div className="flex justify-center mb-3">

              {/* <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">

                <FaHandshake size={28} />

              </div> */}

            </div>

            {/* TITLE */}
            <h1 className="text-2xl md:text-4xl font-bold">
              Partner With Us
            </h1>

            {/* SUBTITLE */}
            <p className="mt-2 text-sm md:text-base opacity-90 max-w-xl mx-auto">
              Grow your business with our trusted healthcare platform.
            </p>

            {/* BTN */}
            <div className="flex justify-center mt-5">

          

            </div>

          </div>
        </div>

        {/* ================= FORM SECTION ================= */}
        <div
          id="partner-form"
          className="px-5 md:px-12 py-10"
        >

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

            {/* NAME */}
            <input
              type="text"
              name="Name"
              value={form.Name}
              onChange={handleChange}
              placeholder="Full Name"
              className="w-full px-5 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
            />

            {/* EMAIL */}
            <input
              type="email"
              name="Email"
              value={form.Email}
              onChange={handleChange}
              placeholder="Email Address"
              className="w-full px-5 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
            />

            {/* PHONE */}
            <div className="flex">

              <span className="px-4 flex items-center bg-gray-100 border border-r-0 rounded-l-2xl">
                +91
              </span>

              <input
                type="text"
                name="Phone"
                value={form.Phone}
                onChange={handleChange}
                placeholder="Mobile Number"
                className="w-full px-5 py-3 border border-gray-200 rounded-r-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
              />

            </div>

            {/* CITY */}
            <input
              type="text"
              name="City"
              value={form.City}
              onChange={handleChange}
              placeholder="City"
              className="w-full px-5 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
            />

            {/* STATE */}
            <input
              type="text"
              name="State"
              value={form.State}
              onChange={handleChange}
              placeholder="State"
              className="w-full px-5 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
            />

            {/* COUNTRY */}
            <input
              type="text"
              name="Country"
              value={form.Country}
              onChange={handleChange}
              placeholder="Country"
              className="w-full px-5 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
            />

          </div>

          {/* ADDRESS */}
          <textarea
            rows="4"
            name="Address"
            value={form.Address}
            onChange={handleChange}
            placeholder="Address"
            className="w-full mt-5 px-5 py-3 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-red-400"
          />

          {/* IMAGE */}
          <input
            type="file"
            onChange={handleImageChange}
            className="mt-5 block"
          />

          {/* BUTTON */}
          <div className="mt-8 flex justify-center">

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="px-12 py-3 rounded-full text-white font-semibold shadow-xl hover:scale-105 transition"
              style={{
                background:
                  "linear-gradient(to right, #ef4444, #dc2626)",
              }}
            >
              {loading
                ? "Submitting..."
                : "Become a Partner"}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
}